import { Box, Container, Stack, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { DashboardLayout } from 'layouts/dashboard/DashboardLayout';
import { AccountProfile } from '../sections/account/AccountProfile';
import { AccountProfileDetails } from '../sections/account/AccountProfileDetails';

const UserProfile = () => {
  return (
    <DashboardLayout>
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth='lg'>
          <Stack spacing={3}>
            <div>
              <Typography variant='h4'>Account</Typography>
            </div>
            <div>
              <Grid container spacing={3}>
                <Grid xs={12} md={6} lg={4}>
                  <AccountProfile />
                </Grid>
                <Grid xs={12} md={6} lg={8}>
                  <AccountProfileDetails />
                </Grid>
              </Grid>
            </div>
          </Stack>
        </Container>
      </Box>
    </DashboardLayout>
  );
};

export default UserProfile;
